import VerifyAdditionalDetails from './VerifyAdditionalDetails';

export default VerifyAdditionalDetails;
